<template>
  <div class="row" style="padding-bottom: 0" >
    <div :class="`col-8 ${color_text} font-general-r d-flex`">
      <v-badge
        right
        :content="`${item.quantity}`"
        :color="color_badge"
        :dark="dark"
        offset-x="15"
        offset-y="10"
        :class="badge"
      >
        <img
          :src="item.product.url_image_flask"
          :alt="item.product.name"
          class="img-product-cart"
        />
      </v-badge>
      <div class="ml-2 mt-1 text-center" style="position: relative">
        <span class="h6 font-weight-bold">
          {{ item.product.name.toUpperCase() }}
        </span><br>
        <span class="h6">{{ item.option_size }}</span><br>
        <div>
          <v-btn
            v-if="item.hasOwnProperty('id')"
            :color="color_remove"
            text
            small
            class="nv-btn-small"
            :loading="loading_btn_remove_cart"
            @click="removeItemCart(item.product.id)"
          >
            QUITAR
          </v-btn>
          <v-btn
            v-else
            :color="color_remove"
            text
            small
            class=" nv-btn-small"
            :loading="loading_btn_remove_cart"
            @click="removeItemCart(item.product.id)"
          >
            QUITAR
          </v-btn>
        </div>
      </div>
    </div>
    <div class="col-4 d-flex align-items-center justify-content-end">
      <p :class="`h6 ${color_text} font-general-l font-weight-bold`">
        {{
          currencyFormat(item.subtotal)
        }}
      </p>
    </div>
  </div>
</template>

<script>
import { currencyFormat } from '@/helpers'

export default {
  props: ['item', 'color_text', 'color_badge', 'dark', 'badge', 'color_remove'],
  data: () => ({
    loading_btn_remove_cart: false
  }),
  methods: {
    currencyFormat(price) {
			return currencyFormat(price)
    },
    removeItemCart(item_id) {
			try {
        this.loading_btn_remove_cart = true
        setTimeout(() => {
          this.$store.dispatch('removeItemCart', { id: item_id })
          this.loading_btn_remove_cart = false
        }, 500)
			} catch (error) {
				this.$notify({
					group: 'admin',
					title: 'Ocurrio un problema: '.error.message,
					type: 'success',
				})
			}
		},
  }
}
</script>

<style scoped>
  >>>.badge-blank .v-badge__wrapper .v-badge__badge {
    color: var(--color-light) !important
  }
  >>>.badge-dark .v-badge__wrapper .v-badge__badge {
    color: var(--color-tertiary) !important
  }
  >>>.v-badge__badge {
    color: var(--color-tertiary) !important;
    font-weight: bold;
  }
</style>

